import React, { Component, } from 'react';
import { object, arrayOf, string } from 'prop-types';

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, } from 'recharts';
import { color, } from '../../../legacy-tv-dls';
import { toPercentage, } from '../../../utils';

const INTERVAL_MAP = {
  '1M': '_1m',
  '3M': '_3m',
  '6M': '_6m',
  '1Y': '_12m',
  'YTM': 'YTM',
};

// const renderLegend = (props) => {
//   const { payload, } = props;

//   return (
//     <ul>
//       {
//         payload.map((entry, index) => (
//           <li key={`item-${index}`}>{entry.name}</li>
//         ))
//       }
//     </ul>
//   );
// };

export default class CummulativeReturn extends Component {
  static propTypes = {
    symbolDetail: object.isRequired,
    selectedIds: arrayOf(string).isRequired,
    // interval: string.isRe/quired
  }
  constructor(props) {
    super(props);
    this.state = {
      selectedSymbol: [],
      displaySymbolMap: {},
      width: 0,
    };
  }
  handleResize = () => {
    setTimeout(() => {
      this.setState({
        width: document.getElementById('line-chart-container-symbol-cr').offsetWidth,
      });
    }, 0);
  };
  updateChartData = (props) => {
    const {
      symbolDetail,
      selectedIds,
      interval,
    } = props;
    let len;
    if (selectedIds.length > 0) {
      len = symbolDetail[selectedIds[0]][INTERVAL_MAP[interval]].cumulative_rtn.length;
    } else {
      return;
    }
    const data = [];
    for (let i = 0; i < len; i++) {
      const { date, } = symbolDetail[selectedIds[0]][INTERVAL_MAP[interval]].cumulative_rtn[i];
      const obj = {
        name: date,
      };
      for (let j = 0; j < selectedIds.length; j++) {
        const { name, } = symbolDetail[selectedIds[j]];
        const v = symbolDetail[selectedIds[j]][INTERVAL_MAP[interval]].cumulative_rtn[i];
        obj[name] = v.value !== 'NULL' ? +v.value : null;
      }
      data.push(obj);
    }
    this.setState({
      selectedSymbol: data,
      displaySymbolMap: selectedIds.reduce((pre, cur) => {
        pre[symbolDetail[cur].name] = true;
        return pre;
      }, {}),
    });
  }
  componentWillReceiveProps(nextProps) {
    this.updateChartData(nextProps);
  }
  componentDidMount() {
    this.updateChartData(this.props);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    const {
      symbolDetail,
      selectedIds,
    } = this.props;
    // const symbolToRender = selectedIds.filter((val, idx) => )
    return (
      <div id="line-chart-container-symbol-cr">
        <ul style={{ marginBottom: 20, }}>
          {
            selectedIds.map(id => (
              <li
                style={{
                  opacity: this.state.displaySymbolMap[symbolDetail[id].name] ? 1 : 0.3,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  const key = symbolDetail[id].name;
                  this.setState({
                    displaySymbolMap: {
                      ...this.state.displaySymbolMap,
                      [key]: !this.state.displaySymbolMap[key],
                    },
                  });
                }}
              >
                {symbolDetail[id].name}
              </li>
            ))
          }
        </ul>
        <LineChart
          width={this.state.width}
          height={400}
          data={this.state.selectedSymbol}
          margin={{
            top: 5, right: 30, left: 20, bottom: 5,
          }}
        >
          <XAxis dataKey="name" interval={Math.floor(this.state.selectedSymbol.length / 10)} />
          <YAxis />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip formatter={d => toPercentage(d)} />
          <Legend />
          {
            selectedIds
              .filter(id => this.state.displaySymbolMap[symbolDetail[id].name])
              .map((id, idx) => {
                const key = symbolDetail[id].name;
                return (
                  <Line
                    key={id}
                    type="monotone"
                    dataKey={key}
                    stroke={color.chart['th' + (idx + 3)]}
                    dot={null}
                  />
                );
              })
          }
        </LineChart>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/SymbolSummary/components/CummulativeReturn.js